module.exports = __webpack_public_path__ + "static/google-play-badge_en-29dd363ba0f9788efea64dc7888fcea5.svg";